import React from 'react';

class TimePicker extends React.Component {
  formatNumber = value => (`0${value}`).slice(-2)

  sendTime = () => {
    const { date } = this.props;

    if (this.props.setDateTime) {
      this.props.setDateTime(date);
    }
  }

  selectHours = async (value) => {
    const { date } = this.props;
    await date.set({ hour: value });
    this.sendTime();
  }

  selectMinutes = async (value) => {
    const { date } = this.props;
    await date.set({ minutes: value });
    this.sendTime();
  }

  render() {
    const { date, disabled = false} = this.props;

    return (
      <div className="time-picker">
        <select
          className="custom-select"
          value={Number(date.format('H'))}
          required
          disabled={disabled}
          onChange={e => this.selectHours(e.target.value)}
        >
          {Array.from(Array(24).keys()).map(h => (
            <option value={h}>
              {this.formatNumber(h)}
            </option>
          ))}
        </select>
        <select
          className="custom-select"
          value={Number(date.format('m'))}
          required
          disabled={disabled}
          onChange={e => this.selectMinutes(e.target.value)}
        >
          {Array.from(Array(60).keys()).map(m => (
            <option value={m}>
              {this.formatNumber(m)}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default TimePicker;
